import { render } from "./DetailInstructionsView.vue?vue&type=template&id=6fda4668&scoped=true&ts=true"
import script from "./DetailInstructionsView.vue?vue&type=script&lang=ts"
export * from "./DetailInstructionsView.vue?vue&type=script&lang=ts"

import "./DetailInstructionsView.vue?vue&type=style&index=0&id=6fda4668&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fda4668"]])

export default __exports__